import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { validateLogin } from "../services/validate-login";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import { v4 as uuidv4 } from "uuid";
import { getFormattedDate } from "../utils/dateFormat";
import { getUserLoanEligibility } from "../services/userService";
import Loader2 from "../components/common/Loader2";

function Form() {
  const [formIsComplete, setFormIsComplete] = useState(false);
  const navigate = useNavigate();

  // Fetch offers from REST API
  useEffect(() => {
    async function fetchLoanProfile() {
      try {
          localStorage.removeItem("step")
      } catch (err) {
        console.error("Error fetching offers:", err);
      } finally {
      }
    }
    fetchLoanProfile();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#f5f9ff] px-4">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row max-w-5xl w-full bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Left side Image (fixed) */}
        <div className="basis-full md:basis-2/5 flex items-center justify-center p-6 bg-gray-50 md:h-[calc(100vh-100px)] md:sticky md:top-0">
          <img
            src="svg/rejection.svg"
            alt="Working professional"
            className="w-full max-w-xs md:max-w-none object-contain"
          />
        </div>

        {/* Right side Form (scrollable) */}
        <div className="basis-full md:basis-3/5 flex flex-col p-8 bg-white relative md:h-[calc(100vh-100px)] md:overflow-y-auto">
          {/* Step Number */}
          {/* <div className="absolute top-4 right-4 bg-blue-100 text-blue-700 text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
            Step 1
          </div> */}

          {/* Scrollable content */}
          <div className="flex-1 overflow-y-auto">
            <h2 className="text-xl font-semibold mb-6">Personal Loan Application Rejected</h2>
            <p className="text-sm text-gray-600 mb-4">
              Sadly, your loan application is rejected. We encourage you to retry after 30 days.
            </p>
          </div>

          {/* Next Button pinned at bottom */}
          <div className="mt-6">
            <button
              className={`w-full px-8 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition
                ${
                  formIsComplete
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-blue-600 text-white hover:bg-blue-700"
                }`}
              onClick={() => {navigate("/dashboard")}}
            >
              Home
            </button>
          </div>
        </div>
      </div>

      {/* Footer Stats */}
      <Footer />
    </div>
  );
}

export default function Sorry() {
  const navigate = useNavigate();

  useEffect(() => {
    validateLogin(navigate);
  }, [navigate]);

  return (
    <div className="flex flex-col h-screen overflow-y-auto">
      <div className="flex-shrink-0">
        <Header title="" />
      </div>

      {/* Main Content scrollable */}
      <main className="flex-1 overflow-y-auto">
        <Form />
      </main>
    </div>
  );
}
